import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title", "aria-label"]
const _hoisted_2 = { key: 0 }

import { computed } from "vue";
import {
  getCompleteParcelWeight,
  getParcelWeightDiscrepancy,
  type DeclaredParcelWeight,
} from "@/utils/parcelWeightDiscrepancy";


export default /*@__PURE__*/_defineComponent({
  __name: 'ParcelWeightWarning',
  props: {
    calculatedWeight: {},
    confirmedParcels: {},
    confirmedCount: {},
    parcels: {},
    expectedCount: {},
    showComparison: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const formatWeight = (weight: number, maximumFractionDigits = 3) =>
  weight.toLocaleString("fr-FR", { maximumFractionDigits });

const warning = computed(() => {
  // Aucun poids confirmé : estimation ; confirmation partielle : pas de comparaison.
  const confirmedWeight = props.confirmedParcels?.some((parcel) => Number(parcel?.poids) > 0)
    ? getCompleteParcelWeight(props.confirmedParcels, props.confirmedCount)
    : undefined;
  const value = getParcelWeightDiscrepancy(
    confirmedWeight !== undefined ? confirmedWeight : props.calculatedWeight,
    Array.isArray(props.parcels) ? props.parcels.slice(0, props.expectedCount) : [],
    props.expectedCount,
  );
  if (!value) return null;
  if (value.kind === "incomplete") {
    return { ...value, details: "Renseignez le poids de tous les colis pour vérifier l’écart de poids." };
  }
  const label = confirmedWeight !== undefined ? "Poids confirmé" : "Poids calculé";
  const comparison = `${label} : ${formatWeight(value.reference)} kg · Poids déclaré : ${formatWeight(value.declared)} kg`;
  return {
    ...value,
    comparison,
    details: `${comparison} · Écart : ${formatWeight(value.percentage, 1)} %`,
  };
});

return (_ctx: any,_cache: any) => {
  return (warning.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        role: "status",
        "aria-live": "polite",
        title: warning.value.details,
        "aria-label": warning.value.details,
        class: _normalizeClass(["mt-1 text-xs leading-tight text-amber-700", _ctx.showComparison ? 'whitespace-normal' : 'whitespace-nowrap'])
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("i", {
          class: "fas fa-exclamation-triangle mr-1",
          "aria-hidden": "true"
        }, null, -1)),
        _createTextVNode(" " + _toDisplayString(warning.value.kind === 'discrepancy' ? 'Écart de poids trop important' : 'Poids à compléter') + " ", 1),
        (_ctx.showComparison && warning.value.kind === 'discrepancy')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (" + _toDisplayString(warning.value.comparison) + ") ", 1))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})